import { Component, OnInit } from "@angular/core";

export type PanOptions =  {min: number, max: number};
export type TiltOptions = {min: number, max: number, large: number};
export type CameraOptions = {zoom: number, pan: PanOptions, tilt: TiltOptions};

@Component({
  selector: "app-full-screen",
  templateUrl: "./full-screen.component.html",
  styleUrls: ["./full-screen.component.scss"]
})
export class FullScreenComponent implements OnInit {

  defaultZoom: number = 50;
  defaultPan: PanOptions = {min: 45, max: 0};
  defaultTilt: TiltOptions = {min: 45, max: 150, large: 180};

  params: CameraOptions = {
    zoom: this.defaultZoom,
    pan: this.defaultPan,
    tilt: this.defaultTilt
  };

  constructor() {

  }

  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    this.params = {
      zoom: urlParams.has("zoom") ? parseInt(urlParams.get("zoom"), 10) : this.defaultZoom,
      pan : { min : urlParams.has("panMin") ? parseInt(urlParams.get("panMin"), 10) : this.defaultPan.min, max: urlParams.has("panMax") ? parseInt(urlParams.get("panMax"), 10) : this.defaultPan.min},
      tilt: {large: this.defaultTilt.large, min: urlParams.has("tiltMin") ? parseInt(urlParams.get("tiltMin"), 10) : this.defaultTilt.min, max: urlParams.has("tiltMax") ? parseInt(urlParams.get("tiltMax"), 10) : this.defaultTilt.max}
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/full-screen/full-screen.component.ts